<template>
  <div class="answerPage">
    <zdy-nav :title="title"
             @back="back"
             :showClose="true"
             @close="close"></zdy-nav>
    <div class="content">
      <div class='Qtext'>
        <div class='QIcon'>Q</div>
        <div class='text'>{{questionName}}</div>
      </div>
      <div class='Atext'>
        <div class='AIcon'>A</div>
        <div class='text'
             v-html="answer"></div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      title: '详情',
      answer: '',
      questionName: ''
    }
  },
  created () {
    const { params } = this.$route;
    this.questionName = params.questionName || params.name;
    this.answer = params.answer || params.value;
  },
  methods: {
    back () {
      this.$router.go(-1);
    },
    close () {
      this.$cjc.closeWebView();
    },
  }
}
</script>

<style lang="scss">
.answerPage {
  .content {
    background-color: #f6f6f6;
    height: calc(100vh - 50px - 20px);
    margin-top: 50px;
    font-size: 14px;
    padding: 20px 15px 0 15px;
    line-height: 20px;
    .Qtext {
      color: #008cff;
      display: flex;
      margin-bottom: 12px;
      .QIcon {
        display: inline-block;
        color: #fff;
        width: 24px;
        height: 24px;
        font-size: 15px;
        background: #008cff;
        // opacity: 1;
        border-radius: 12px;
        text-align: center;
        line-height: 24px;
        margin-right: 8px;
      }
      .text {
        flex: 1;
        font-size: 16px;
        line-height: 24px;
        font-weight: bold !important;
      }
    }
    .Atext {
      color: #8F8F8F;
      display: flex;
      .AIcon {
        color: #fff;
        width: 24px;
        height: 24px;
        font-size: 14px;
        background: #8F8F8F;
        border-radius: 12px;
        text-align: center;
        line-height: 24px;
        margin-right: 8px;
      }
      .text {
        flex: 1;
        font-size: 14px;
        line-height: 24px;
        font-weight: bold !important;
      }
    }
  }
}
</style>